import { isDev } from '@/utils/environment';
import { AlertTriangle } from 'lucide-react';
import { useEffect, useState } from 'react';

export const ErrorWarning = () => {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    if (!isDev()) {
      return;
    }

    const errorHandler = (event: ErrorEvent) => {
      console.error('Error caught:', event.error);
      setHasError(true);
    };

    window.addEventListener('error', errorHandler);
    return () => window.removeEventListener('error', errorHandler);
  }, []);

  if (!isDev() || !hasError) {
    return null;
  }

  return (
    <div
      className={`
        fixed bottom-4 right-4 bg-red-500 text-white p-2 rounded-full
        cursor-pointer hover:bg-red-600 transition-colors
      `}
    >
      <AlertTriangle size={24} />
    </div>
  );
};
